import { render, staticRenderFns } from "./BusRouteList.vue?vue&type=template&id=3a58dcb0&scoped=true&"
import script from "./BusRouteList.vue?vue&type=script&lang=js&"
export * from "./BusRouteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a58dcb0",
  null
  
)

export default component.exports